import React from 'react';
import styles from './Home.module.scss';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';
import InvitationModal from '../../components/common/Modals/Invtiation/InvitationModal';
import useHomeStore from '../../store/homeStore';
import { useInitDatasetBriefs } from '../../queries/useDatasetBriefsQuery';
import { useSilentAuth } from '../../queries/useSilentAuthenticationQuery';
import { useNotificationsBsQuery } from '../../queries/useNotificationsBsQuery';
import LoadModal from '../../components/common/Loading/LoadModal';
import Header from '../../components/layout/Header/Header';
import { useRoute } from '../../hooks/useRoute';
import { useHeaderPopup } from '../../hooks/useHeaderPopup';
import { HeaderContainer } from '../../components/common/Modals/Menu/Container/HeaderContainer';
import { BannersContainer } from '../../components/common/Modals/Menu/Container/BannerContainer';

export default function Home({ children }: { children?: React.ReactNode }) {
  const {
    showAdvertisingBanner,
    setShowAdvertisingBanner,
    setShowCart,
    setShowUserProfile,
  } = useHomeStore();
  const navigate = useNavigate();

  useRoute();
  useSilentAuth();
  useInitDatasetBriefs();
  useNotificationsBsQuery();

  const { closeAllModals, navigateToHome } = useHeaderPopup();

  const handleAdvertisingBannerClick = () => {
    const newValue = showAdvertisingBanner === 'true' ? 'false' : 'true';
    setShowAdvertisingBanner(newValue);
  };

  const handleCloseCart = () => setShowCart(false);

  const handleCheckout = () => {
    handleCloseCart();
    navigate('checkout');
  };

  const handleCloseUserProfile = () => setShowUserProfile(false);

  return (
    <InvitationModal>
      <Layout className={styles.root}>
        <Header advertisingBannerClick={handleAdvertisingBannerClick} />
        <Content>
          <HeaderContainer
            onNavigateHome={navigateToHome}
            onCloseAllModals={closeAllModals}
            onCloseCart={handleCloseCart}
            onCheckout={handleCheckout}
            onCloseUserProfile={handleCloseUserProfile}
          />
          <BannersContainer />
          {children}
        </Content>
        <LoadModal />
      </Layout>
    </InvitationModal>
  );
}
